import { render, staticRenderFns } from "./TaxonomyKeywords.vue?vue&type=template&id=9c9a470a&"
import script from "./TaxonomyKeywords.vue?vue&type=script&lang=js&"
export * from "./TaxonomyKeywords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports